module.exports = __webpack_public_path__ + "static/img/im.701022c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-teacher-downloads/im.jpg
// module id = CELZ
// module chunks = 1